exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".create_dropzone_14b {\n  margin: 20px;\n  width: calc(100% - 40px);\n  height: 400px; }\n", "", {"version":3,"sources":["/Users/nicolaythafvelin/efoil/logger-webapp/src/routes/session/create.scss"],"names":[],"mappings":"AAIA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc,EAAE","file":"create.scss","sourcesContent":[":export {\n  primaryColor: #00bcd4;\n  accentColor: #ff5722; }\n\n.dropzone {\n  margin: 20px;\n  width: calc(100% - 40px);\n  height: 400px; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"primaryColor": "#00bcd4",
	"accentColor": "#ff5722",
	"dropzone": "create_dropzone_14b"
};